import React from 'react';
import { StreamWithChatRate } from '../types';
import { HeatRail } from './HeatRail';
import { IconDiscord, IconX } from './icons';
import './Header.css';

interface HeaderProps {
  onToggleSidebar?: () => void;
  sidebarVisible?: boolean;
  /** e.g. "@ppy's list" or "a shared list" while viewing someone's list */
  sharedLabel?: string | null;
  chatConnected?: boolean;
  streams?: StreamWithChatRate[];
  selectedId?: string | null;
  onStreamSelect?: (stream: StreamWithChatRate) => void;
}

export const Header: React.FC<HeaderProps> = ({
  onToggleSidebar,
  sidebarVisible,
  sharedLabel,
  chatConnected = true,
  streams = [],
  selectedId,
  onStreamSelect,
}) => {
  return (
    <header className="app-header">
      <div className="header-left">
        {onToggleSidebar && (
          <button
            className="header-menu-btn"
            onClick={onToggleSidebar}
            aria-label={sidebarVisible ? 'Close stream list' : 'Open stream list'}
          >
            {sidebarVisible ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M3 12h18M3 6h18M3 18h18" />
              </svg>
            )}
          </button>
        )}
        <a className="brand" href="/">
          <img src="/pogchamp.png" alt="" className="brand-emote" />
          <span className="brand-word">
            pogchamp<span className="brand-tld">.tv</span>
          </span>
        </a>
        {sharedLabel && (
          <span className="shared-list-pill">
            watching <strong>{sharedLabel}</strong>
          </span>
        )}
      </div>
      <HeatRail streams={streams} selectedId={selectedId} onStreamSelect={onStreamSelect} />
      <div className="header-right">
        <span
          className={`scan-status ${chatConnected ? '' : 'down'}`}
          title={chatConnected ? 'Chat monitor is connected' : 'Chat monitor lost connection — reconnecting'}
        >
          <span className="scan-dot" />
          <span className="scan-label">reconnecting</span>
        </span>
        <span className="header-sep" />
        <a
          className="header-icon-link"
          href="https://discord.gg/CSWHkcH8Ee"
          target="_blank"
          rel="noopener noreferrer"
          title="Join the Discord"
        >
          <IconDiscord size={17} />
        </a>
        <a
          className="header-icon-link"
          href="https://x.com/not_pr0"
          target="_blank"
          rel="noopener noreferrer"
          title="@not_pr0 on X"
        >
          <IconX size={14} />
        </a>
      </div>
    </header>
  );
};
